import { BellIcon } from "lucide-react";

import { Separator } from "@/components/ui/separator";

import { EmptyState } from "@/shared/components/EmptyState";
import { AppNotification } from "@/features/notifications/types";

import { NotificationCard } from "./NotificationCard";

interface NotificationListProps {
  notifications: AppNotification[];
  permissions: string[];
}

export function NotificationList({ notifications, permissions }: NotificationListProps) {
  if (notifications.length === 0) {
    return <EmptyState icon={BellIcon} title="No notifications here" description="Try a different filter." />;
  }

  return (
    <div className="flex flex-col">
      {notifications.map((n, i) => (
        <div key={n.id}>
          <NotificationCard notification={n} permissions={permissions} />
          {i < notifications.length - 1 && <Separator />}
        </div>
      ))}
    </div>
  );
}
